import { render, staticRenderFns } from "./addJxHomeUrl.vue?vue&type=template&id=45fa49ca"
import script from "./addJxHomeUrl.vue?vue&type=script&lang=js"
export * from "./addJxHomeUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports